// Empresa no Admin (spec ux-wave §4.2): formato do CompaniesController + status de desativação.
export type AdminCompany = {
  id: number;
  name: string;
  cnpj: string;
  address?: string;
  cep: string;
  managersCount?: number;
  openPackagesCount?: number;
  active?: boolean;
  deactivatedAt?: string | null;
  deactivationReason?: string | null;
  deactivatedBy?: { id: number; name: string } | null;
  legacy?: boolean;
  /** S5: opcionais, para aplicar feriados municipais/estaduais na sazonalidade. */
  city?: string | null;
  uf?: string | null;
};

// `active` ausente conta como ativa (payloads antigos).
export const isInactive = (company: { active?: boolean }) => company.active === false;
export const REASON_MIN = 5;
export const REASON_MAX = 500;
